import { Team } from "../../../types/calendarSettings";
import labels from "../../../utils/labels";
import TeamSettingsRow from "./TeamSettingsRow";
import RowCell from "../../UI/table/RowCell";

const TeamSettingsList = ({ teams }: { teams: Team[] }) => {
  return (
    <ul className="flex flex-col">
      <li className="flex" data-header>
        <RowCell width={174}>{labels.nexusTeamHex}</RowCell>
        <RowCell>{labels.pondooTeamName}</RowCell>
        <RowCell>{labels.groupEmployeesInTeams}</RowCell>
      </li>
      {teams.map((team) => (
        <TeamSettingsRow
          key={team.hexCode}
          colorHex={team.hexCode}
          chipColor={team.hexCode}
          teamName={team.teamName}
          grouped={team.grouped}
        />
      ))}
    </ul>
  );
};

export default TeamSettingsList;
